export default process.env.NODE_ENV != "production"
  ? {
      node_api_endpoint: "http://localhost:4004",
      // mock_api_endpoint: "http://192.168.0.196:5001",
      // kyc_api_endpoint: "http://192.168.0.95:5051",
      // kyc_api_endpoint: "http://localhost:5051",
      kyc_api_endpoint: "https://kyc.getcupi.com/api",
      Client_Id: "21k0cgope0hvi22dikd805pbes", //77fglk6ill774c4v5toavua4md//simadmin
    }
  : {
      node_api_endpoint: "https://portalapi.getcupi.com",
      kyc_api_endpoint: "https://kyc.getcupi.com/api",
      Client_Id: "21k0cgope0hvi22dikd805pbes",
    };
